module.exports = __webpack_public_path__ + "static/media/t2.98bd3e93.jpg";